import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreConfigTemplate = {
    facilityCodes: [],
    scoreOnMatch: 0,
  };
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addScore = () => {
    updateData((draft) => {
      draft.scores.push(structuredClone(scoreConfigTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((draft) => {
      draft.scores.splice(index, 1);
    });
  };

  return (
    <>
      <table className="config-table table-with-button">
        <thead>
          <tr>
            <th>Merchant facility codes</th>
            <th>Score</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={() => addScore()}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.scores.map((score, index) => (
            <tr key={index}>
              <td>
                <input
                  type="text"
                  value={UtilService.arrayToCsv(score.facilityCodes)}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].facilityCodes =
                        UtilService.csvToStringArray(e.target.value);
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  min={0}
                  value={score.scoreOnMatch}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].scoreOnMatch = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
